import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { HelmetProvider } from "react-helmet-async"; // ✅ ADD THIS

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <HelmetProvider> {/* ✅ ADD THIS */}
    <Provider store={store}>
      <App />
    </Provider>
  </HelmetProvider>
);
